import { Field, useFormContext } from '@oscar/form';
import { Button, Col, Row } from '@oscar/theme';
import { TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { useAuth } from 'features/auth';
import { useEffect } from 'react';
import { useState } from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import ReinstatementChecklist from './ReinstatementChecklist';
import './styles.scss';

const Qaqc: React.FC<{ statusRequest?: StatusInstance }> = ({
  statusRequest,
}) => {
  const [auth] = useAuth();
  const [showList, setShowlist] = useState(false);
  const [checkValue, setCheckValue] = useState(false);
  const [dataCheckList, setDataCheckList] = useState();

  const handleClose = () => {
    setShowlist(false);
  };

  const getCheckValue = (data: any) => {
    let result = false;
    if (data) {
      Object.keys(data).forEach(key => {
        if (key && data[key]) {
          result = true;
        }
      });
    }
    return result;
  };

  const [formContext] = useFormContext();
  const startDate = formContext.form?.getFieldValue('startDate');
  const endDate = formContext.form?.getFieldValue('endDate');
  useEffect(() => {
    const reinstatementChecklist =
      formContext.form?.getFieldsValue()?.reinstatementChecklist;
    setCheckValue(getCheckValue(reinstatementChecklist));
  }, []);

  const handleOnChange = (data: any) => {
    if (getCheckValue(data)) {
      data.inspectedBy = auth.getUserInformation().fullName;
      setDataCheckList(data);
    }
  };

  return (
    <div className="qaqc-detail">
      <Row gutter={10}>
        <Field name="reinstatementChecklist">
          <ReinstatementChecklist
            visible={showList}
            onClose={handleClose}
            startDate={startDate}
            endDate={endDate}
            onChange={handleOnChange}
          />
        </Field>
        <div className="container">
          <Field name={['reinstatementChecklist', 'overallAcceptance']}>
            <TextField
              label="Inspection Result"
              mappingData={[
                { value: undefined, label: 'Pending QAQC' },
                { value: true, label: 'Accepted' },
                { value: false, label: 'Rejected' },
              ]}
            />
          </Field>
          {statusRequest?.state === 'EDIT' && (
            <Button
              className="checklist-button"
              onClick={() => {
                setShowlist(true);
              }}
            >
              OPEN CHECKLIST
            </Button>
          )}
        </div>
      </Row>
      {checkValue || dataCheckList ? (
        <Row gutter={12}>
          <Col span={12}>
            <Field name={['reinstatementChecklist', 'inspectedBy']}>
              <TextField label="Inspection By" />
            </Field>
          </Col>
          <Col span={12}>
            <Field name={['reinstatementChecklist', 'inspectionDate']}>
              <TextField
                label="Inspection Date"
                isDate
                formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
              />
            </Field>
          </Col>
        </Row>
      ) : (
        <Row gutter={12}>
          <Col span={12}>
            <TextField label="Inspection By" value={'Pending QAQC'} />
          </Col>
          <Col span={12}>
            <TextField label="Inspection Date" value={'Pending QAQC'} />
          </Col>
        </Row>
      )}
    </div>
  );
};
export default Qaqc;
